import React from 'react';
import useMatchMedia from '@dashboard/hooks/useMatchMedia';

const PanelStateContext = React.createContext();
const PanelDispatchContext = React.createContext();

function panelReducer(state, action) {
  switch (action.type) {
    case 'toggle': {
      return {
        ...state,
        [action.panel]: !state.preview,
      };
    }
    case 'open': {
      return {
        ...state,
        [action.panel]: true,
      };
    }
    case 'close': {
      return {
        ...state,
        [action.panel]: false,
      };
    }
    case 'set': {
      return {
        ...state,
        [action.panel]: action.value,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function PanelProvider({ children }) {
  const isSmall = useMatchMedia('(max-width: 768px)');
  const [state, dispatch] = React.useReducer(panelReducer, {
    preview: isSmall ? false : true,
    nav: false,
    main: true,
  });

  return (
    <PanelStateContext.Provider value={state}>
      <PanelDispatchContext.Provider value={dispatch}>
        {children}
      </PanelDispatchContext.Provider>
    </PanelStateContext.Provider>
  );
}

function usePanelState() {
  const context = React.useContext(PanelStateContext);

  if (context === undefined) {
    throw new Error('usePanelState must be used within a PanelProvider');
  }

  return context;
}

function usePanelDispatch() {
  const context = React.useContext(PanelDispatchContext);

  if (context === undefined) {
    throw new Error('usePanelDispatch must be used within a PanelProvider');
  }

  return context;
}

function usePanel() {
  return [usePanelState(), usePanelDispatch()];
}

export { PanelProvider, usePanel };
